import { TemplateType } from '@rentguru/commons-utils';
import { toLower } from 'lodash';

export const TEMPLATE_MAIL_ROUTE = toLower(TemplateType.MAIL);
export const TEMPLATE_CONTRACT_ROUTE = toLower(TemplateType.CONTRACT);
export const TEMPLATE_SMS_ROUTE = toLower(TemplateType.SMS);
